import ActionType from './ActionType';

const headerMenuRouterMap={
    0:ActionType.TO_HOME,
    1:ActionType.TO_ABOUTE_JW,
    2:ActionType.TO_BUSSINESS_SCOPE,
    3:ActionType.TO_ABOUT_POLICY,
    4:ActionType.TO_FOCUS_NEWS,
    5:ActionType.TO_TECH_FINANCE,
    6:ActionType.TO_RECRUITMENT,
    7:ActionType.TO_CONTACT_US
}

const routePathMap={
    TO_HOME:'/home',
    TO_ABOUTE_JW:'/about',
    TO_BUSSINESS_SCOPE:'/bussiness',
    TO_ABOUT_POLICY:'/policy',
    TO_FOCUS_NEWS:'/news',
    TO_RECRUITMENT:'/recruitment',
    TO_TECH_FINANCE:'/techFinance',
    TO_CONTACT_US:'/recruitment#contact-us'
}


export const headerMenuRouterAction=(routerId)=>{
    let t=headerMenuRouterMap[routerId];
    return {
        type:t,
        path:routePathMap[t]
    }
}
